import React from 'react';

import { DEFAULT_ANNUAL_PRICE, SPECIAL_OFFER_PRICE } from '../../utils/backend-api/subscribe';
import GiftForm from '../Subscription/Gift/GiftForm';
import styles from './styles.module.css';

const DISCOUNT_PERCENT_OFF = Math.round(100 - (SPECIAL_OFFER_PRICE / DEFAULT_ANNUAL_PRICE) * 100);

const LandingGiftForm = ({ setCurrentFormStep, setNumberOfGifts }) => {
  return (
    <>
      <div className={styles.giftSectionHeader}>
        <div className={styles.settingsSectionHeadingText}>Gift Subscriptions</div>
        <div className={styles.settingsSectionHeadingLine}></div>
      </div>
      <div className={styles.giftSubHeader} id="GiftSubHeader">
        Give a year of The Information for ${SPECIAL_OFFER_PRICE} ({DISCOUNT_PERCENT_OFF}% off) for
        the first year—our gift to you and your community. If you&rsquo;d like to extend your gift
        beyond one year, the subscription will renew at our standard rate of ${DEFAULT_ANNUAL_PRICE}
        .
      </div>
      <GiftForm
        forGiftLandingPage
        setCurrentFormStep={setCurrentFormStep}
        setNumberOfGifts={setNumberOfGifts}
      />
    </>
  );
};

export default LandingGiftForm;
